import { Controller } from "@hotwired/stimulus"

// Fires a one-off toast when the element mounts — used to surface a server-side
// event (e.g. "you set a PR") as a toast after a redirect.
export default class extends Controller {
  static values = {
    message: String,
    type: { type: String, default: "info" }
  }

  connect() {
    if (!this.messageValue) return

    window.dispatchEvent(
      new CustomEvent("toast:show", {
        detail: { message: this.messageValue, type: this.typeValue }
      })
    )
  }
}
